import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CourseTypeForm from '../../../components/forms/CourseTypeForm';
import { useCreateCourseType } from '../../../hooks/useCourseTypeApi';
import { useNavigate } from 'react-router-dom';
import { CourseTypeDTO } from '../../../services/apiClient';

const CourseTypeCreate: React.FC = () => {
  const createCourseType = useCreateCourseType();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Course Types', href: '/admin/coursetypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: CourseTypeDTO) => {
    try {
      setIsSubmitting(true);
      await createCourseType.mutateAsync(data);
      navigate('/admin/coursetypes');
    } catch (error) {
      console.error('Error creating CourseType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/coursetypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.CourseType.Edit"
    >
      <CourseTypeForm
        initialValues={{} as CourseTypeDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/coursetypes')}
        isLoading={isSubmitting}
      />
    </AdminLayout>
  );
};

export default CourseTypeCreate;
